export default {"src":"/_next/static/media/discord.ab1aeebf.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};